export const devices = {
  title: 'RPM Devices',
  hardwareOrGatewayIdLabel: 'Hardware ID or Gateway ID',
  searchButton: 'Search',
  notAvailable: 'N/A',
  unavailable: 'Unavailable',
  grid: {
    patientName: 'Patient Name',
    devices: 'Devices',
    hardwareId: 'Hardware Id',
    gatewayId: 'Gateway Id',
    lastReadingDate: 'Last Reading Date',
    lastReading: 'Last Reading',
    deviceStatus: 'Device Status',
    lastGatewayCheckIn: 'Last Gateway Check-in'
  },
  snackbars: {
    unknownError: 'Unknown error occurred',
    unableToGetAccounts: 'Unable to get accounts'
  }
} as const;
